<template>
  <div class="sc-form-input">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScFormInput'
}
</script>

<style lang="scss" scoped>
  .sc-form-input {
    display: flex;
    flex-direction: column;

    input {
      padding: 10px;
      color: $sc-forminput-color;
      border: $sc-forminput-border;
      outline: none;
    }

    label{
      align-self: flex-start;
      color: $sc-forminput-title-color;
      margin-bottom: 6px;
    }
  }
</style>
